$(document).on('click', '.fullWidth', function(){

    sessionStorage.setItem('infoMsgState', 'hideInfoMessage');
    $('.fullWidth').remove()
})

$(document).ready(function(){
    if (sessionStorage.getItem('infoMsgState') === 'hideInfoMessage') {

    }
    else{
        $('body').prepend('<div class="fullWidth" style="background:url('+bgImage+')"><img src="/user/documents/upload/sablona-nemazat/logo-towell-symbol-white.svg" alt="towell logo"><span class="btn btn-enter">Vstoupit</a></div>')
    }
})